<template>
  <div class="content-warpper">
    <div class="warpper-title flex align-center justify-between">
      <div>
        <i class="iconfont icontongji1"></i>
        统计信息
      </div>
    </div>
    <div class="padding-sm statistics">
      <h3>实习总数量</h3>
      <div class="flex align-center">
        <div class="statistics-item"><i>实习机构数量 </i> <b>{{ sxNum1 }}个</b></div>
        <div class="statistics-item"><i>发布岗位数量 </i> <b>{{ sxNum2 }}人</b></div>
        <div class="statistics-item"><i>实习学生数量 </i> <b>{{ sxNum3 }}人</b></div>
      </div>
      <h3 class="margin-top active">实习实时统计</h3>
      <div class="flex align-center">
        <div class="statistics-item active"><i>正在发布实习岗位的<br>机构数量 </i> <b>{{ sxNum4 }}个</b></div>
        <div class="statistics-item active"><i>正在发布的<br>岗位数量 </i> <b>{{ sxNum5 }}人</b></div>
        <div class="statistics-item active"><i>正在申请实习的<br>学生数量 </i> <b>{{ sxNum6 }}人</b></div>
      </div>
    </div>
  </div>
</template>

<script>
import {getSxStatistics} from "@/api/coordinate";

export default {
  name: "index3",
  data() {
    return {
      sxNum1: 0,
      sxNum2: 0,
      sxNum3: 0,
      sxNum4: 0,
      sxNum5: 0,
      sxNum6: 0,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "当前位置：<span>统计信息</span>", false);
    this.getTj()
  },
  methods: {
    async getTj() {
      let _data = await getSxStatistics()
      this.sxNum1 = _data.data.total.org_num
      this.sxNum2 = _data.data.total.gw_num
      this.sxNum3 = _data.data.total.student_num
      this.sxNum4 = _data.data.now.org_num
      this.sxNum5 = _data.data.now.gw_num
      this.sxNum6 = _data.data.now.student_num
    }
  }
}
</script>

<style scoped lang="scss">
.statistics {
  h3 {
    font-size: 22px;
    color: #009688;
    line-height: 46px;
    margin-bottom: 10px;

    &.active {
      color: #00a2d4;
    }
  }

  .statistics-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    width: 300px;
    height: 100px;
    padding: 20px;
    background: #009688;
    box-shadow: 0 10px 10px #aaa;
    margin-right: 30px;
    font-size: 18px;
    border-radius: 5px;

    &.active {
      background: #00a2d4;
    }
    i{
      line-height: 150%;
      //text-align: center;
    }
    b {
      font-size: 26px;
    }
  }
}
</style>